import { render, staticRenderFns } from "./PageSectionWithoutForm.vue?vue&type=template&id=6d152a8a"
import script from "./PageSectionWithoutForm.vue?vue&type=script&lang=js"
export * from "./PageSectionWithoutForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports